<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content" v-if="showChangePassword" v-loading="loading">
        <div>
          <div class="text-center login_title login_titleBox">
            <img src="../assets/images/login_logo.png" />
            《{{ $store.state.Name }}》 —
            <span class="highorange">修改密码</span>
          </div>
        </div>
        <div class="login_maxBox">
          <div class="container center-block regist" style="max-width: 600px">
            <p style="color: #ff5f27">
              因国家网络安全法要求，必须使用强密码（密码要求必须包含字母、数字、特殊字符），您的密码不符合要求，请尽快修改。
            </p>
            <el-form
              ref="form"
              :model="form"
              label-width="100px"
              class="twenfive"
            >
              <el-form-item label="姓名:">
                <el-col :md="14" :lg="14" :xl="14" :sm="14">
                  {{ this.form.name }}
                </el-col>
                <div class="clearfix"></div>
              </el-form-item>
              <el-form-item label="用户名:">
                <el-col :md="14" :lg="14" :xl="14" :sm="14">
                  <label>{{ this.form.user }}</label>
                </el-col>
                <div class="clearfix"></div>
              </el-form-item>
              <el-form-item label="邮箱:">
                <el-col :md="7" :lg="7" :xl="7" :sm="7">
                  <label>{{ this.form.email }}</label>
                </el-col>
                <div class="clearfix"></div>
              </el-form-item>
              <el-form-item label="手机:">
                <el-col :md="7" :lg="7" :xl="7" :sm="7">
                  <label>{{ this.form.mobil }}</label>
                </el-col>
                <div class="clearfix"></div>
              </el-form-item>
              <el-form-item label="验证码:" :rules="[{ required: true }]">
                <el-col :md="8" :lg="8" :xl="8">
                  <el-input
                    v-model="form.picyzcodes"
                    placeholder="请输入图片验证码"
                    @blur="DetectInput($event, 'Piccodes')"
                    @input="DetectKey($event, 'Piccodes')"
                  ></el-input>
                </el-col>
                <el-col
                  :md="6"
                  :lg="6"
                  :xl="6"
                  :sm="6"
                  class="leftfloat ml1 myzm"
                >
                  <span style="cursor: pointer">
                   <img
                            @click="initVeri()"
                            width="100"
                            class="yamsss"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                  </span>
                </el-col>
                <div class="clearfix"></div>
                <div class="five five msg_error" style="zoom: normal">
                  <span v-html="picCodeTiShi"></span>
                  <span v-html="codeTiShis"></span>
                </div>
              </el-form-item>
              <div class="clearfix"></div>
              <div class="twenfive" v-if="status == 0">
                <el-col
                  :md="6"
                  :lg="6"
                  :xl="6"
                  :sm="6"
                  class="leftfloat ml1 myzm"
                  v-if="form.email!=''"
                >
                  <el-button
                    class="five"
                    type="primary"
                    plain
                    @click="sendCodeBtn(1)"
                    style="color: #fff"
                    >发送邮箱验证码</el-button
                  >
                </el-col>
                <el-col
                  :md="6"
                  :lg="6"
                  :xl="6"
                  :sm="6"
                  class="leftfloat ml1 myzm"
                  v-if="form.mobil!=''"
                >
                  <el-button
                    class="five"
                    type="primary"
                    plain
                    @click="sendCodeBtn(2)"
                    style="color: #fff"
                    >发送手机验证码</el-button
                  >
                </el-col>
                <el-col
                  :md="6"
                  :lg="6"
                  :xl="6"
                  :sm="6"
                  class="leftfloat ml1 myzm"
                >
                  <el-button
                    class="five"
                    style="width: 100%"
                    v-if="status == 0"
                    @click="$router.push('/')"
                    >取消</el-button
                  >
                </el-col>
              </div>
              <template v-if="status == 1">
                <div class="twenfive" style="margin-top: 0px">
                  <div class="highgreen" v-if="emailormobil == 1">
                    系统已经发送验证码到邮箱，若未收到验证码，请到邮件垃圾箱中查找一下。
                  </div>
                  <div class="highgreen" v-if="emailormobil == 2">
                    系统已经发送验证码到手机，请注意查收。
                  </div>
                </div>
                <el-form-item label="验证码:" :rules="[{ required: true }]">
                  <el-col :md="14" :lg="14" :xl="14">
                    <el-input
                      v-model="form.yzcodes"
                      placeholder="请输入验证码"
                      @blur="DetectInput($event, 'codes')"
                      @input="DetectKey($event, 'codes')"
                    ></el-input>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="msg_error" v-html="codeTiShi1"></div>
                </el-form-item>

                <div class="clearfix"></div>
                <el-form-item label="新密码:" :rules="[{ required: true }]">
                  <el-col :md="14" :lg="14" :xl="14">
                    <el-input
                      v-model="form.newPwd"
                      placeholder="请输入新密码"
                      @blur="DetectInput($event, 'pass')"
                      @input="DetectKey($event, 'pass')"
                      show-password
                    ></el-input>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="five highgray five" style="zoom: normal">
                    <span
                      >密码须设置为8~16位的字母、数字、特殊字符.!@#_组合。</span
                    >
                  </div>
                  <div class="msg_error" v-html="pwdTiShi"></div>
                </el-form-item>
                <el-form-item label="确认密码:" :rules="[{ required: true }]">
                  <el-col :md="14" :lg="14" :xl="14">
                    <el-input
                      v-model="form.RePawd"
                      placeholder="请重新键入您的密码"
                      @blur="DetectInput($event, 'rpwd')"
                      @input="DetectKey($event, 'rpwd')"
                      show-password
                    ></el-input>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="five highgray five" style="zoom: normal">
                    <span>请确认您的新密码。</span>
                  </div>
                  <div class="msg_error" v-html="rpwdTiShi"></div>
                </el-form-item>

                <el-form-item label>
                  <el-button style="width: 48%" type="primary" @click="submit()"
                    >提交</el-button
                  >
                  <el-button
                    style="width: 48%"
                    class="ml1"
                    @click="$router.push('/')"
                    >取消</el-button
                  >
                  <div class="highgreen ten" v-if="showsuess">
                    <i class="el-icon-success"></i>修改成功！
                  </div>
                </el-form-item>
              </template>
            </el-form>
            <div class="clearfix"></div>
            <div class="fifth"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var time;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      showChangePassword: false,
      userInfo: [],
      userTishi: "",
      EmailTiShi: "",
      src: "",
      loading: true,
      isweixin: false,
      codeImg: require("../assets/images/timg.jpg"),
      codeTiShis: "",
      ycodeTiShis: "",
      picCodeTiShi: "",
      status: 0,
      emailormobil: 0,
      Picture: "",
      wait: 60,
      dialogVisible: false,
      GUID: "",
      Btn1: "发送邮箱验证码",
      form: {
        user: "",
        name: "",
        email: "",
        mobil: "",
        picyzcodes: "",
        yzcodes: "",
        emails: "",
        newPwd: "",
        RePawd: "",
      },
      timer: null,
    };
  },
  created() {
    localStorage.removeItem("route");
  },
  async mounted() {
    this.initVeri();
    if (this.$route.query.Guid) {
      let data = {
        data: this.$route.query.Guid,
      };
      let res = await this.$store.dispatch("_ClanUserLogin", data);
      if (res.data.IsSuccess) {
        this.form.mobil = res.data.Data.Mobile;
        this.form.user = res.data.Data.UserName;
        this.form.name = res.data.Data.Name;
        this.form.email = res.data.Data.EmailBox;
        if (!res.data.Data.IsGo) {
          this.showChangePassword = true;
          this.userInfo = res.data.Data;
          this.loading = false;
          return;
        }
        localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
        this.$store.dispatch("_GetRouter").then((res) => {
          localStorage.setItem("route", JSON.stringify(res.data.Data));
        });

        this.timer = setTimeout(() => {
          window.location.href = res.data.Data.GoPath;
        }, 2500);
      } else {
        this.$message({
          showClose: true,
          message: res.data.Message,
          type: "err",
        });
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    //页面初始化形成验证码以及GUID
       async initVeri() {
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID;
        this.Picturebase = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
      timeCode(str) {
      //验证码时间定时器
      time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = "重新发送验证码";
          this.wait = 60;
          this.codess = false;
          clearInterval(time);
        } else {
          this.Btn = "验证码(" + this.wait + ")";
          this.wait--;
        }
      }, 1000);
    },
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == "emails") {
        if (this.$Bai(elem.target.value)) {
          return (this.EmailTiShi = "请输入邮箱");
        }
        if (this.$Space(elem.target.value)) {
          return (this.EmailTiShi = "邮箱不能含有空格");
        }

        if (!this.$base(elem.target.value, "email")) {
          return (this.EmailTiShi = "请输入正确格式的邮箱");
        } else {
          return (this.EmailTiShi = "");
        }
      }
      if (type == "Piccodes") {
        if (this.$Bai(elem.target.value)) {
          return (this.picCodeTiShi = "请输入图片验证码");
        } else {
          return (this.picCodeTiShi = "");
        }
      }

      if (type == "opass") {
        if (!elem.target.value || elem.target.value == "") {
          return (this.opwdTiShi = "原密码不能为空");
        } else {
          this.opwdTiShi = "";
        }
      }
      if (type == "pass") {
        if (!elem.target.value || elem.target.value == "") {
          return (this.pwdTiShi = "新密码不能为空");
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi = "新密码不能小于八位字符");
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = "新密码不能含有空格");
        } else if (this.$base(elem.target.value, "aff")) {
          return (this.pwdTiShi = "新密码中含有非法字符");
        } else if (!this.$base(elem.target.value, "pass")) {
          return (this.pwdTiShi =
            "请输入8~16位的字母、数字、特殊字符.!@#_组合，不允许为空");
        } else {
          this.pwdTiShi = "";
        }
      }
      if (type == "rpwd") {
        if (elem.target.value == "" || !elem.target.value) {
          return (this.rpwdTiShi = "确认密码不能为空");
        } else if (elem.target.value.length < 8) {
          return (this.rpwdTiShi = "确认密码不得少于八位字符");
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = "密码不能含有空格");
        } else if (this.form.pass != this.form.rpass) {
          return (this.rpwdTiShi = "两次输入密码不同");
        } else {
          this.rpwdTiShi = "";
        }
      }
      if (type == "user") {
        if (elem.target.value == "" || !elem.target.value) {
          this.userTishi = "用户名不能为空";
          return;
        } else {
          this.userTishi = "";
        }
      }
    },
    DetectKey(elem, type) {
      let base = this.base;
      if (type == "phone") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.phoneTiShi = "");
      } else if (type == "Piccodes") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.codeTiShi1 = "");
      } else if (type == "pwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.pwdTiShi = "");
      } else if (type == "rpwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.rpwdTiShi = "");
      } else {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.EmailTiShi = "");
      }
    },
    //0:email 1:手机
    sendCodeBtn(Type) {
      // debugger
      let codes = this.form.picyzcodes;
      if (this.form.user == "" || !this.form.user) {
        this.$message({
          showClose: true,
          message: "用户名不能为空",
          type: "error",
        });
        return;
      }
      let MobileEmail = "";
      if (Type == 1) {
        MobileEmail = this.form.email;
      } else {
        MobileEmail = this.form.mobil;
      }
      if (Type==1&&this.$Bai(this.form.email)) {
        this.$message({
          showClose: true,
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
       if (Type==2&&this.$Bai(this.form.mobil)) {
        this.$message({
          showClose: true,
          message: "手机不能为空",
          type: "error",
        });
        return;
      }
      if (codes == "" || codes == null || codes == undefined) {
        this.codeTiShis = "验证码不能为空";
        return;
      } else {
        if (codes.length < 6) {
          this.codeTiShis = "请输入正确的验证码";
          return;
        } else {
          this.codeTiShis = "";
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return;
      }
      this.$store
        .dispatch("_getRegSendCode", {
          MobileEmail: MobileEmail,
          CRCeMethod: Type,
          LookforPassword: true,
          VCode: this.form.picyzcodes,
          Guid: this.GUID,
          UserName: this.form.user,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.emailormobil = Type;
            this.timeCode();
            this.status = 1;
          } else {
            this.initVeri();
            this.$message({
              showClose: true,
              message: res.data.Message,
              type: "error",
            });
          }
        });
    },
    submit() {
      let status = 0;
      if (this.status == 0) {
        return;
      }
      if (this.$Bai(this.form.yzcodes)) {
        status = 1;
        this.codeTiShi1 = "验证码不能为空";
      } else if (this.form.yzcodes.length < 6) {
        status = 1;
        this.codeTiShi1 = "请输入6位数的验证码";
      } else if (this.$base(this.form.yzcodes, "aff")) {
        status = 1;
        this.codeTiShi1 = "验证码中含有非法字符";
      }
      if (this.form.yzcodes == "" || !this.form.yzcodes) {
        status = 1;
        this.ycodeTiShis = "邮箱验证码不能为空";
      }
      if (this.form.newPwd == "" || !this.form.newPwd) {
        status = 1;
        this.pwdTiShi = "密码不能为空";
      } else if (this.form.newPwd.length < 8) {
        status = 1;
        this.pwdTiShi = "密码不能小于8位字符";
      } else if (this.$Space(this.form.newPwd)) {
        status = 1;
        this.pwdTiShi = "密码不能含有空格";
      } else if (this.$base(this.form.newPwd, "aff")) {
        status = 1;
        this.pwdTiShi = "密码中含有非法字符";
      } else if (!this.$base(this.form.newPwd, "pass")) {
        status = 1;
        this.pwdTiShi =
          "请输入8~16位的字母、数字、特殊字符.!@#_组合，不允许为空";
      }
      if (this.form.RePawd == "" || !this.form.RePawd) {
        status = 1;
        this.rpwdTiShi = "确认密码不能为空";
      } else if (this.form.RePawd.length < 8) {
        status = 1;
        this.rpwdTiShi = "确认密码不能小于8位字符";
      } else if (this.$Space(this.form.RePawd)) {
        status = 1;
        this.rpwdTiShi = "确认密码不能含有空格";
      } else if (this.$base(this.form.RePawd, "aff")) {
        status = 1;
        this.rpwdTiShi = "确认密码中含有非法字符";
      } else if (this.form.newPwd != this.form.RePawd) {
        status = 1;
        this.rpwdTiShi = "两次密码输入不一致";
      }
      if (status == 1) {
        return;
      }
      let npwm = md5(this.form.newPwd + "!@*Samson*@!");
      let pwaes = CryptoJS.AES.encrypt(this.form.newPwd, npwm).toString();
      var data = {
        UserName: this.form.user,
        EmailBox: this.form.email,
        Mobile: this.form.mobil,
        VCode: this.form.yzcodes,
        Pwm: npwm,
      };
      this.$store.dispatch("_ClanLoginChangePassword", data).then((res) => {
        if (res.data.IsSuccess) {
          localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
         this.$message({
            showClose: true,
            message: "修改密码成功，跳转中·······",
            duration:1000,
            type: "success"
          });
        setTimeout(() => this.$router.push("/Login"), 1500);
        } else {
          this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
          return;
        }
      });
    },
  },
};
</script>
<style scoped>
</style>